import React, { useState, useEffect, useCallback } from 'react';
import './ExchangeRateSection.css';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const LabelingFeeSection = ({ user }) => {
  const [fees, setFees] = useState([]);
  const [editValues, setEditValues] = useState({});
  const [saving, setSaving] = useState(false);

  const fetchFees = useCallback(async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/labeling-fees`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        setFees(data);
        const values = {};
        data.forEach((f) => { values[f.key] = String(f.fee); });
        setEditValues(values);
      }
    } catch (err) {
      console.error('載入貼標費用失敗', err);
    }
  }, []);

  useEffect(() => { fetchFees(); }, [fetchFees]);

  const handleChange = (key, value) => {
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setEditValues((prev) => ({ ...prev, [key]: value }));
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      const payload = Object.entries(editValues).map(([key, fee]) => ({
        key,
        fee: parseFloat(fee) || 0,
      }));
      const res = await fetch(`${API_URL}/labeling-fees`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ fees: payload }),
      });
      if (res.ok) {
        const data = await res.json();
        setFees(data);
      }
    } catch (err) {
      console.error('儲存貼標費用失敗', err);
    } finally {
      setSaving(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '尚未設定';
    const d = new Date(dateStr);
    return d.toLocaleString('zh-TW', {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit',
    });
  };

  const isManager = user?.role === 'manager';

  return (
    <section className="section exchange-rate-section">
      <div className="section-header">
        <h2>
          <span className="section-number">2</span>
          貼標費用
        </h2>
      </div>
      <div className="rate-grid">
        {fees.map((f) => (
          <div key={f.key} className="rate-item">
            <div className="form-group">
              <label>{f.label}</label>
              <div className="rate-input-wrapper">
                <input
                  type="text"
                  inputMode="decimal"
                  className="form-control"
                  value={editValues[f.key] ?? ''}
                  onChange={(e) => handleChange(f.key, e.target.value)}
                  disabled={!isManager}
                />
                <span className="rate-unit">{f.currency}</span>
              </div>
              <span className="rate-updated">最後更新：{formatDate(f.updatedAt)}</span>
            </div>
          </div>
        ))}
      </div>
      {isManager && (
        <div className="rate-actions">
          <button className="btn btn-primary btn-sm" onClick={handleSave} disabled={saving}>
            {saving ? '儲存中...' : '儲存貼標費用'}
          </button>
        </div>
      )}
    </section>
  );
};

export default LabelingFeeSection;
